import { Navigate, NavigateProps } from 'react-router-dom'

import { buildLocalizedPath } from '../utils/localization'

export function LocalizedNavigate(props: NavigateProps) {
  return <Navigate {...props} to={buildLocalizedPath(props.to as string)}></Navigate>
}
